import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SignInService {
  constructor(private http: HttpClient) {}

  PasswordSignIn(email: string, password: string): Observable<object> {
    return this.http
      .post('/api/SignIn/PasswordSignIn', { email: email, password: password })
      .pipe(map((data) => data));
  }

  Admin(email: string): Observable<object> {
    return this.http
      .post('/api/SignIn/Admin', { email: email })
      .pipe(map((data) => data));
  }

  TwoFactorAuthenticatorSignIn(code: string): Observable<any> {
    let params = new HttpParams();
    params = params.append('code', code);
    return this.http
      .get('/api/SignIn/TwoFactorAuthenticatorSignInByEmailAsync', {
        params: params,
        responseType: "text"
      })
      .pipe((val) => val);
  }

  refreshToken(): Observable<string> {
    return this.http
      .post<{ token: string }>('/api/SignIn/refresh-token', {}, { withCredentials: true })
      .pipe(
        map(res => {
          if (!res || typeof res.token !== 'string') {
            throw new Error('Réponse invalide de refresh-token : token manquant'); // defensive
          }
          return res.token;
        })
    );
  }

  signOut(): Observable<object> {
    return this.http.get('/api/SignIn/SignOut').pipe(map((data) => data));
  }
}
